export const TRACKER_EVENT_NAME = 'CERITA_PRAKTIK'
export const TRACKER_QUERY_SOURCE_KEY = 'source'
export const TRACKER_QUERY_SOURCE_VALUE_IDE_PRAKTIK = 'ide-praktik'
